import * as types from "../actions/types";

const initialState = {
  loading: false
};

export default function directoryBasicEducation(state = initialState, action) {
  switch (action.type) {

    case types.GET_TRACK_PROFILE_LIST:
      return {
        ...state,
        trackProfileList: action.payload
      };
    case types.GET_TRACK_PROFILE_CURR:
      return {
        ...state,
        trackProfileCurr: action.payload
      };
    case types.GET_STUDY_SHIFTS_LIST:
      return {
        ...state,
        studyShiftsList: action.payload
      };
    case types.GET_STUDY_MANNERS_LIST:
      return {
        ...state,
        mannersList: action.payload
      };
    case types.GET_JOURNAL_MANNERS_LIST:
      return {
        ...state,
        journalMannersList: action.payload
      };
    case types.GET_HOMEWORKS: //TODO
      return {
        ...state,
        homework: action.payload
      };
    case types.GET_JORNAL_CONTROL: //TODO
      return {
        ...state,
        journalControl: action.payload
      };
    case types.GET_JORNAL_CONTROL_COURSES: //TODO
      return {
        ...state,
        journalControlCourses: action.payload
      };
    case types.GET_DIGITAL_EXAM_BOOK: //TODO
      return {
        ...state,
        digitalExamBook: action.payload
      };
    case types.GET_HOMEWORK_LIST_BASEEDUC: //TODO
      return {
        ...state,
        getHomeworks: action.payload
      };
    case types.GET_SUBGROUP_LIST_COURSES:
      return {
        ...state,
        subgroupCourses: action.payload
      };
    case types.GET_SUBGROUP_CLASS_LIST:
      return {
        ...state,
        subgroupClasses: action.payload
      };
    case types.GET_SUBGROUP_TABLES_LIST:
      return {
        ...state,
        tableList: action.payload
      };
    case types.GET_SUBGROUP_BY_ID:
      return {
        ...state,
        subgroup: action.payload
      };
    case types.GET_SUBGROUP_GROUPUSER:
      return {
        ...state,
        subgroupGroupusers: action.payload
      };
    case types.GET_SUBGROUP_AVAILABLE_GROUPS:
      return {
        ...state,
        subgroupAvailableGroups: action.payload
      };
    case types.GET_SUBGROUP_AVAILABLE_STUDENTS:
      return {
        ...state,
        subgroupAvailableStudents: action.payload
      };
    case types.GET_SUBGROUP_MAIN:
      return {
        ...state,
        subgroupMain: action.payload
      };
    case types.GET_SUBGROUP_MEMBERS:
      return {
        ...state,
        subgroupMembers: action.payload
      };
    case types.GET_SUBGROUP_HISTORY:
      return {
        ...state,
        subgroupHistory: action.payload
      };
    case types.GET_SUBGROUP_CANDIDATES:
      return {
        ...state,
        subgroupCandidates: action.payload
      };
    case types.GET_SUBGROUP_OWNER_HISTORY:
      return {
        ...state,
        subgroupOwnerHistory: action.payload
      };
    case types.GET_SUBGROUP_ELECTIVE_YEARS:
      return {
        ...state,
        subgroupElectiveYears: action.payload
      };

    case types.SET_BASIC_EDUCATION_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    default:
      return state;
  }
}